import { each, assign } from 'lodash';
import { NotificationProgrammatic } from 'buefy';
import { BaseUIService } from '/@/modules/core/ui/services/BaseUIService';
import { TranslateResult } from 'vue-i18n';
import type { App } from 'vue';
import { NotificationCypressAttribute } from '/@/modules/notification/constants/NotificationCypressAttribute';


let notificationInstance: NotificationProgrammatic | null = null;

// Type definitions for Buefy Vue 3
interface BNoticeComponent {
  close: () => void;
  $refs: Record<string, unknown>;
}

interface BNoticeConfig {
  message?: string;
  type?: string;
  position?: string;
  duration?: number;
  container?: string;
  queue?: boolean;
  [key: string]: unknown;
}

export type NotificationOptions = {
  type?: string;
  position?: string;
  active?: boolean;
  animation?: string;
  duration?: number;
  container?: string;
  queue?: boolean;
};

export class NotificationService extends BaseUIService {
  notificationComponents: BNoticeComponent[] = [];

  setApp(app: App): void {
    notificationInstance = new NotificationProgrammatic(app);
  }

  show(
    messages: string | string[] | TranslateResult | TranslateResult[],
    options: NotificationOptions = {}
  ): void {
    this.closeAll();
    this.pushMessages(messages, options);
  }

  private pushMessages(
    messages: string | string[] | TranslateResult | TranslateResult[],
    options: NotificationOptions = {}
  ): void {
    options.type = 'is-dark';
    options.duration = options.duration ?? 10000;

    if (Array.isArray(messages)) {
      options.queue = false;
    } else {
      messages = [messages];
    }

    each(messages, (message: string | TranslateResult) => {
      if (!notificationInstance) {
        throw new Error('NotificationService: app not initialized. Call setApp() first.');
      }
      const component: BNoticeComponent = notificationInstance.open(
        assign(options, { message }) as BNoticeConfig
      );

      component.$el?.setAttribute?.('data-e2e', NotificationCypressAttribute.views.NOTIFICATION_MESSAGE);
      this.notificationComponents.push(component);
    });
  }

  private closeAll(): void {
    this.notificationComponents.forEach((component: BNoticeComponent) => {
      if (component.$refs.notification) {
        component.close();
      }
    });
    this.notificationComponents = [];
  }
}

export default new NotificationService();